import { render, staticRenderFns } from "./BCXMessengerChatGroupConversationHeader.vue?vue&type=template&id=3d6e52bb&scoped=true"
import script from "./BCXMessengerChatGroupConversationHeader.vue?vue&type=script&lang=ts&setup=true"
export * from "./BCXMessengerChatGroupConversationHeader.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./BCXMessengerChatGroupConversationHeader.vue?vue&type=style&index=0&id=3d6e52bb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d6e52bb",
  null
  
)

export default component.exports